(function () {
  'use strict';

  function sanitize(str) {
    const div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }

  function initStickyCart() {
    const mainBtn = document.querySelector('.product-form__submit');
    if (!mainBtn) return;

    // Build sticky bar
    const bar = document.createElement('div');
    bar.id = 'dc-sticky-cart';
    bar.innerHTML = `
      <div class="dc-sticky__inner">
        <div class="dc-sticky__info">
          <img class="dc-sticky__img" src="" alt="" />
          <div class="dc-sticky__meta">
            <span class="dc-sticky__title"></span>
            <span class="dc-sticky__price"></span>
          </div>
        </div>
        <button class="dc-sticky__btn button button--primary" type="button"></button>
      </div>
    `;

    // Set button text safely
    bar.querySelector('.dc-sticky__btn').textContent = mainBtn.textContent.trim();
    document.body.appendChild(bar);

    // Populate product info with null-safe checks
    const img   = document.querySelector('.product__media-item img');
    const title = document.querySelector('.product__title h1, .product__title h2');
    const price = document.querySelector('.price__regular .price-item, .price-item--regular');

    if (img)   bar.querySelector('.dc-sticky__img').src = img.src;
    if (title) bar.querySelector('.dc-sticky__title').textContent = title.textContent.trim();
    if (price) bar.querySelector('.dc-sticky__price').textContent = price.textContent.trim();

    // Show/hide based on main button visibility
    if (typeof IntersectionObserver !== 'undefined') {
      const observer = new IntersectionObserver(
        ([entry]) => bar.classList.toggle('dc-sticky--visible', !entry.isIntersecting),
        { threshold: 0 }
      );
      observer.observe(mainBtn);
    }

    // Trigger the main form's add-to-cart button
    bar.querySelector('.dc-sticky__btn').addEventListener('click', () => mainBtn.click());
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyCart);
  } else {
    initStickyCart();
  }
})();
